var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMcLogoBorderKlm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "27px",
    viewBox: "0 0 41 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mc_logo_border_klm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KLM",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mc_logo_border_klm",
    transform: "translate(0.500000, 0.500000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L38,0 C39.1045695,-2.02906125e-16 40,0.8954305 40,2 L40,24 C40,25.1045695 39.1045695,26 38,26 L2,26 C0.8954305,26 1.3527075e-16,25.1045695 0,24 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z",
    id: "Path",
    stroke: "#C7D3D8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F06022",
    points: "16.13 19.29 23.87 19.29 23.87 6.7 16.13 6.7 16.13 19.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.93,13 C16.9226285,10.5407209 18.0566861,8.21719576 20,6.71 C16.7998592,4.19127425 12.2200791,4.47079135 9.35,7.36 C7.85020576,8.85370909 7.0071167,10.8832691 7.0071167,13 C7.0071167,15.1167309 7.85020576,17.1462909 9.35,18.64 C12.2200791,21.5292087 16.7998592,21.8087257 20,19.29 C18.0674859,17.7740492 16.9361749,15.4561514 16.93,13",
    id: "Path",
    fill: "#EA1D25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0000404,13 C33.0000404,15.12 32.16,17.15 30.66,18.65 C27.770286,21.5071546 23.2107976,21.780895 20,19.29 C21.9289734,17.7711895 23.0593924,15.4551194 23.07,13 C23.0728141,10.5417688 21.939684,8.22014393 20,6.71 C23.1994285,4.18262518 27.785938,4.45798786 30.66,7.35 C32.1640232,8.84473376 33.0067651,10.8795592 33.0000404,13",
    id: "Path",
    fill: "#F79D1D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcLogoBorderKlm);
export default __webpack_public_path__ + "static/media/mc_logo_border_klm.829b14ea4a11c7bf112dd42b84332329.svg";
export { ForwardRef as ReactComponent };